// extracted by mini-css-extract-plugin
export default {"page":"Page_page__M0vJ1","key-image":"Page_key-image__D71no","title":"Page_title__PURD+","richtext":"Page_richtext__C0mtL"};